import { Input as WDSInput, InputProps as WDSInputProps } from "@datamole/wds-component-input";
import { clsx } from "clsx";
import { forwardRef } from "react";

import styles from "@/components/ui/input/input.module.css";

type Props = WDSInputProps & {
    hasError?: boolean;
};

const Input = forwardRef<HTMLInputElement, Props>(({ className, hasError, ...props }, ref) => {
    return (
        <WDSInput
            ref={ref}
            className={clsx(styles.default_input, className, { [styles.input_error]: hasError })}
            {...props}
        />
    );
});

Input.displayName = "Input";

export { Input };
export type { Props as InputProps };
